<script lang="ts">
  import { t } from '../../lib/i18n/index.svelte.js'
  import { EMOJI_CHOICES } from '../../lib/utils/emoji.js'
  import Button from '../ui/Button.svelte'
  import Sheet from '../ui/Sheet.svelte'

  interface Props {
    open: boolean
    current: string | null
    onpick: (emoji: string | null) => void
    onclose: () => void
  }
  const { open, current, onpick, onclose }: Props = $props()

  let custom = $state('')
</script>

<Sheet {open} title="Emoji" {onclose}>
  <div class="grid">
    {#each EMOJI_CHOICES as emoji}
      <button class="cell" class:active={emoji === current} onclick={() => onpick(emoji)}>
        {emoji}
      </button>
    {/each}
  </div>
  <div class="custom">
    <input
      bind:value={custom}
      maxlength="8"
      placeholder="…"
      aria-label="Emoji"
      onkeydown={(e) => {
        if (e.key === 'Enter' && custom.trim()) onpick(custom.trim())
      }}
    />
    <Button onclick={() => custom.trim() && onpick(custom.trim())}>{t('save')}</Button>
    <Button variant="ghost" onclick={() => onpick(null)}>{t('remove')}</Button>
  </div>
</Sheet>

<style>
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
    gap: var(--space-1);
  }
  .cell {
    aspect-ratio: 1;
    border: 1px solid transparent;
    border-radius: var(--radius);
    background: transparent;
    font-size: 24px;
  }
  .cell:hover {
    background: var(--surface-2);
  }
  .cell.active {
    border-color: var(--accent);
    background: var(--accent-soft);
  }
  .custom {
    display: flex;
    gap: var(--space-2);
    margin-top: var(--space-4);
    padding-top: var(--space-4);
    border-top: 1px solid var(--border);
  }
  .custom input {
    width: 72px;
    padding: var(--space-2);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--surface);
    text-align: center;
    font-size: 20px;
  }
</style>
